import { useBlockEnvironment } from '@zillow/cms-blocks';
import { useRouter } from 'next/router';
import React from 'react';

import LayoutHead from '../LayoutHead';
import OptimizelyScripts from '../OptimizelyScripts';
import { PreviewModeAlert } from '../PreviewModeAlert';

export type LayoutWrapperProps = {
    children: React.ReactNode;
    head: string;
    preview?: boolean;
    submenu?: unknown;
    menu?: unknown;
    isBlog?: boolean;
    header?: { disabled?: boolean; transparent?: boolean };
    LayoutComponent: React.ComponentType<{
        router: ReturnType<typeof useRouter>;
        environment: string;
        submenu?: unknown;
        menu?: unknown;
        header?: LayoutWrapperProps['header'];
        children: React.ReactNode;
        knotchAccountId?: string;
    }>;
    defaultTitle: string;
    NavComponent?: React.ComponentType<unknown>;
    knotchAccountId?: string;
    [key: string]: unknown;
};

const LayoutWrapper: React.FC<LayoutWrapperProps> = ({
    children,
    head,
    preview,
    submenu,
    menu,
    header,
    LayoutComponent,
    defaultTitle,
    knotchAccountId,
    ...restProps
}) => {
    const { environment = 'prod' } = useBlockEnvironment();
    const router = useRouter();

    return (
        <>
            <LayoutHead
                head={head}
                preview={preview}
                defaultTitle={defaultTitle}
            />
            <LayoutComponent
                router={router}
                environment={environment}
                submenu={submenu}
                menu={menu}
                header={header}
                knotchAccountId={knotchAccountId}
                {...restProps}
            >
                <OptimizelyScripts />
                {children}
                {preview && <PreviewModeAlert />}
            </LayoutComponent>
        </>
    );
};

export default LayoutWrapper;
